import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { hasAuthSession } from "../../helpers/routeAccess";

const Authmiddleware = (props) => {
  const authToken  = useSelector(state => state.auth.jid)
  if (!hasAuthSession(authToken)) {
    return (
      <Navigate to={{ pathname: "/login" }} replace />
    );
  }
  return (
    <React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
